import styled from 'styled-components/macro';
export const Flex = styled.div`
  display: flex;
  width: ${({ width }) => (width ? 'wrap' : '100%')};
  height: ${({ height }) => (height ? height : '100%')};
  flex-direction: ${({ column }) => (column ? 'column' : 'row')};
  flex-wrap: ${({ wrap }) => (wrap ? 'wrap' : 'nowrap')};
  position: ${({ position }) => (position ? 'position' : 'relative')};
`;
